export const locale = {
  lang: 'en',
  data: {
    PRONOSTICO: {
      PRONOSTICO_SUCCESS: 'Success',
      PRONOSTICO_ERROR: 'Error',
      PRONOSTICO_COMMUNICATION_ERROR: 'Communication Error'
    }
  }
}
